export default __webpack_public_path__ + "static/media/star-filled.0516a919.svg";